import { MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { buildUrlQueryParams, getTranslateByKey, isShowControlByElementId } from "@/main/services/utils";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { Controls } from "@/main/services/constants/constantsControl";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { OrderStatusEnum } from "@/main/services/enum/OrderStatusEnum";
import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";

interface IOptionReassignPartSearchClaimProps {
	guidQuote: string;
	guidPart: string;
	guidQuoteProcurement: string;
	guidProcurementSupplierItem: string;
	externalPartId: string;
	claimNumber: string;
	isStripePayment: boolean;
	idStatus: number;
	cancelationPending: boolean;
	showReassignCanceledBySupplier: boolean;
}
function OptionReassignPartSearchClaim({
	guidQuote,
	externalPartId,
	guidPart,
	guidProcurementSupplierItem,
	guidQuoteProcurement,
	idStatus,
	isStripePayment,
	cancelationPending,
	showReassignCanceledBySupplier,
}: IOptionReassignPartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();
	const navigate = useNavigate();

	const showReassignButtonByStatus = [
		OrderStatusEnum.Assigned,
		OrderStatusEnum.Delivered,
		OrderStatusEnum.Received,
		OrderStatusEnum.Invoiced,
		OrderStatusEnum.Paid,
		OrderStatusEnum.Transit,
	];
	const isReassignableByStatus =
		idStatus !== ProcurementStatusEnum.Paid && showReassignButtonByStatus.includes(idStatus) && !cancelationPending;
	const showReassignButton =
		isShowControlByElementId(Controls.IdReassignPart) &&
		(isReassignableByStatus || showReassignCanceledBySupplier) &&
		!isStripePayment;

	function handleReassignPart() {
		const routeReassignOrder = buildUrlQueryParams(RoutesConstants.orderReassignOrder, {
			guidQuote,
			guidPart,
			guidQuoteProcurement,
			guidProcurementSupplierItem,
			externalPartId,
			previousRoute: RoutesConstants.claimSearchClaims,
			canceledBySupplier: showReassignCanceledBySupplier ? "true" : undefined,
		});
		navigate(routeReassignOrder);
		closeThreeDotsPartClaim();
	}

	if (!showReassignButton) return <OptionEmptySearchClaim option="OptionReassign" />;
	return (
		<MenuItem
			id={generateIdMenu(`reassign-part-${guidQuoteProcurement}-${guidProcurementSupplierItem}`)}
			onClick={handleReassignPart}
		>
			{getTranslateByKey("information.reassignPartToAnotherSupplier")}
		</MenuItem>
	);
}

export default OptionReassignPartSearchClaim;
